import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MessageReplyTemplateItem } from 'services/message-reply-templates';
import { createCombineAction } from 'utils/store';
import { actionAccountLogout } from '../account';

interface Filters {
  search: string;
}

interface State {
  data: MessageReplyTemplateItem[];
  isLoading: boolean;
  error: null | Error;
  filters: Filters;
  isInit: boolean;
}

const initState = (): State => {
  return {
    data: [],
    isLoading: false,
    isInit: false,
    error: null,
    filters: {
      search: '',
    },
  };
};

const slice = createSlice({
  name: 'MESSAGE_TEMPLATES',
  initialState: initState(),
  reducers: {
    getMessageReplyTemplatesRequest(state) {
      state.error = null;
      state.isLoading = true;
    },
    getMessageReplyTemplatesSuccess(
      state,
      action: PayloadAction<{
        value: any[];
      }>,
    ) {
      const { value } = action.payload;
      state.isLoading = false;
      state.data = value;
    },
    getMessageReplyTemplatesFail(state, action: PayloadAction<{ error: Error }>) {
      state.error = action.payload.error;
      state.isLoading = false;
    },
    actionMessageReplyTemplatesSetFilters(state, action: PayloadAction<Partial<Filters>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (build) => {
    build.addCase(actionAccountLogout.fulfilled, () => {
      return initState();
    });
  },
});

const action = slice.actions;
export const { actionMessageReplyTemplatesSetFilters } = action;

export const actionMessageReplyTemplatesGet = createCombineAction(
  action.getMessageReplyTemplatesRequest,
  action.getMessageReplyTemplatesSuccess,
  action.getMessageReplyTemplatesFail,
);

export const reducerReplyMessageTemplates = slice.reducer;
